import type { ReactElement } from "react"
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined"
import EditNoteIcon from "@mui/icons-material/EditNote"
import GroupsIcon from "@mui/icons-material/Groups"
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer"
import TableRowsIcon from "@mui/icons-material/TableRows"
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"

import type {
    TeamMemberRole,
    UiStageType,
    WorkflowViewMode,
} from "./documentWorkflowTypes"

type StageTypeStyle = {
    color: string
    border: string
    background: string
}

type WorkflowViewModeConfig = {
    labelId: string
    labelFallback: string
    icon: ReactElement
}

export const SHOW_CURRENT_STAGE_TOGGLE_BUTTON = false

export const viewModeConfig: Record<
    WorkflowViewMode,
    WorkflowViewModeConfig
> = {
    overview: {
        labelId: "document-workflow-view-overview",
        labelFallback: "_Overview",
        icon: <VisibilityOutlinedIcon fontSize="small" />,
    },
    summary: {
        labelId: "document-workflow-view-summary",
        labelFallback: "_Summary view",
        icon: <GroupsIcon fontSize="small" />,
    },
    stages: {
        labelId: "document-workflow-view-stages",
        labelFallback: "_Stages view",
        icon: <TableRowsIcon fontSize="small" />,
    },
    wfl: {
        labelId: "document-workflow-view-definition",
        labelFallback: "_Workflow definition",
        icon: <AccountTreeOutlinedIcon fontSize="small" />,
    },
}

export const stageActionLabels: Record<UiStageType, string> = {
    EDIT: "Dodaj edytora",
    REVIEW: "Dodaj opiniujacego",
    APPROVAL: "Dodaj zatwierdzajacego",
}

export const stageTypeStyles: Record<UiStageType, StageTypeStyle> = {
    EDIT: {
        color: "#1976D2",
        border: "#5FA8E8",
        background: "#EAF4FF",
    },
    REVIEW: {
        color: "#EF6C00",
        border: "#FFB680",
        background: "#FFF4E8",
    },
    APPROVAL: {
        color: "#2E7D32",
        border: "#74C37A",
        background: "#EAF7EA",
    },
}

export const stageTypeChipIcons: Record<UiStageType, ReactElement> = {
    EDIT: <EditNoteIcon />,
    REVIEW: <QuestionAnswerIcon />,
    APPROVAL: <TaskAltOutlinedIcon />,
}

export const stageTypeLabels: Record<UiStageType, string> = {
    EDIT: "Opracowanie",
    REVIEW: "Opiniowanie",
    APPROVAL: "Zatwierdzanie",
}

export const roleChipColor: Record<
    TeamMemberRole,
    "success" | "info" | "warning" | "error"
> = {
    Autor: "success",
    Edytor: "info",
    Opiniujacy: "warning",
    Zatwierdzajacy: "error",
}

export const getStageTypeChipSx = (
    stageType: UiStageType,
    isCurrent = false
) => ({
    color: stageTypeStyles[stageType].color,
    borderColor: stageTypeStyles[stageType].border,
    bgcolor: stageTypeStyles[stageType].background,
    borderWidth: isCurrent ? "2.5px" : 1,
    borderStyle: "solid",
    fontWeight: isCurrent ? 700 : 600,
    "& .MuiChip-icon": {
        color: "inherit",
    },
})